import React from 'react'
import { Button, Divider, Grid, Hidden, Typography, useMediaQuery } from '@mui/material'
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import Icon2 from "assets/images/Parallax/Icon/Fossil Management Fund (8).png";
import Icon3 from "assets/images/Parallax/Icon/Fossil Management Fund (9).png";
import { ParseHtml } from 'utilities/utilities';
import MenuHomeAll from './MenuHomeAll';
import { useNavigate } from 'react-router';

const DashboardManage = () => {

    const arrMenu = [
        {
            key: "sd5re4wr14dgfg445rer",
            icon: Icon2,
            title: "Dashboard",
            detail: "ข้อมูลการเก็บ<span>รายได้</span><br/>พิพิธภัณฑ์<br/>กรมทรัพยากรธรณี",
            link: "/IncomeDashboard",
        },
        {
            key: "sd5re478wr4544445rer",
            icon: Icon2,
            title: "Dashboard",
            detail: "ข้อมูล<span>รายจ่าย</span><br/>กองทุนจัดการ<br/>ซากดึกดำบรรพ์",
            link: "/ExpenseDashboard",
        },
        {
            key: "sd5re4wrsdsver78445rer",
            icon: Icon3,
            title: "Dashboard",
            detail: "<span>ข้อมูล</span>สถิติ<br/>โครงการที่ได้รับ<br/>การสนับสนุน",
            link: "/ProjectSupportDashboard",
        }
    ];
    const navigate = useNavigate();
    const onGotoPage = (link) => {
        navigate(link);
    }
    const LayoutWeb = useMediaQuery('(min-width:1190px)');
    const Layoutipad = useMediaQuery('(min-width:1180px)');
    const LayoutipadVertical = useMediaQuery('(min-width:820px)');
    const LayoutPhone = useMediaQuery('(min-width:932px)');
    return (
        <React.Fragment>
            {LayoutWeb || Layoutipad ? (
                <div className='session-c-container'>
                    <div style={{ padding: '0 65px', width: '100%', display: 'flex' }}>
                        {arrMenu.map(item => {
                            return (
                                <div key={item.key} className='session-c-card-key' >
                                    <div className='session-c-card'>
                                        <div style={{ minHeight: LayoutWeb ? '45vh' : '30vh' }}>
                                        </div>
                                        <Grid container spacing={1} alignItems='center'>
                                            <Grid item >
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    loading="lazy"
                                                />
                                            </Grid>
                                            <Grid item >
                                                <Typography className='session-c-title'>
                                                    {ParseHtml(item.title)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider orientation='horizontal' flexItem className='session-c-card-hori' />
                                        <Typography className='session-c-detail'>
                                            {ParseHtml(item.detail)}
                                        </Typography>
                                        <Button variant="contained"
                                            onClick={(e) => { onGotoPage(item.link) }}
                                            startIcon={<EastRoundedIcon />}
                                            sx={{ ".MuiButton-startIcon": { margin: '0' } }} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            ) :
                <div className={LayoutipadVertical && !LayoutPhone ? 'session-c-container-ipad' : 'session-c-container-phone'}>
                    {arrMenu.map(item => {
                        return (
                            <div key={item.key} className='session-c-card-key-phone' >
                                <div className={LayoutipadVertical && !LayoutPhone ? 'session-c-card-ipad' : 'session-c-card-phone'}>
                                    <div style={{ minHeight: LayoutPhone ? '10vh' : '20vh' }}>
                                    </div>
                                    <Grid container spacing={1} alignItems='center'>
                                        <Grid item >
                                            <img
                                                src={item.icon}
                                                alt={item.title}
                                                loading="lazy"
                                                style={{ width: '30px', height: '30px' }}
                                            />
                                        </Grid>
                                        <Grid item >
                                            <Typography className={LayoutipadVertical && !LayoutPhone ? 'session-c-title-ipad' : 'session-c-title-phone'} >
                                                {ParseHtml(item.title)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Divider orientation='horizontal' flexItem className='session-c-card-hori' />
                                    <Typography className={LayoutipadVertical && !LayoutPhone ? 'session-c-detail-ipad' : 'session-c-detail-phone'}>
                                        {ParseHtml(item.detail)}
                                    </Typography>
                                    <Button variant="contained" 
                                     onClick={(e) => { onGotoPage(item.link) }}
                                     style={{ width: '15px', height: '25px' }} startIcon={<EastRoundedIcon />} sx={{ ".MuiButton-startIcon": { margin: '0' } }} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
        </React.Fragment>
    )
}

export default DashboardManage
